/**
 * How often clients poll for site announcements (landing strip + dashboard banners).
 * Email is also sent for new announcements; polling is a while-you're-on-site backup.
 */
export const SITE_ANNOUNCEMENTS_POLL_INTERVAL_MS = 120_000;

/** BroadcastChannel — other tabs refetch when an admin publishes or removes an announcement. */
export const SITE_ANNOUNCEMENTS_BROADCAST_CHANNEL = 'bhg-site-announcements';

export const SITE_ANNOUNCEMENTS_CHANGED_EVENT = 'bhg-site-announcements-changed';
